import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HOTEL_APPLICATION_DATA_QUERY } from "./schema";

export const useHotelApplicationDataQuery = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(HOTEL_APPLICATION_DATA_QUERY, { variables: { hotelID } });

	return {
		hotelApplicationData: data,
	};
};
